import { call, put } from "redux-saga/effects";
import firebase from "firebase";
import { signInWithGoogleFailureAction, signInWithGoogleSuccessAction } from "../actions";
import { auth } from "../../../../config/firebase";
import createFirestoreUserDoc from "./createFirestoreUserDoc";
import getCurrentUserAuthorization from "../../../../utils/getAuthorizationToken";

const provider = new firebase.auth.GoogleAuthProvider();

async function signInWithGoogleInFirebase() {
  return auth
    .signInWithPopup(provider)
    .then((res) => res)
    .catch((error) => error.code);
}

export default function* callSignInWithGoogleSaga() {
  try {
    // @ts-ignore
    const result = yield call(signInWithGoogleInFirebase);
    if (result.user) {
      const authToken: string = yield call(getCurrentUserAuthorization);

      // @ts-ignore
      const resultUserCreation = yield call(
        createFirestoreUserDoc,
        result.user?.uid,
        result.user?.displayName,
        result.user?.email,
        result.user?.photoURL,
        "google",
        authToken
      );
      if (resultUserCreation.status === "success") {
        yield put(signInWithGoogleSuccessAction(result.user?.uid));
      } else {
        throw new Error(JSON.stringify(resultUserCreation));
      }
    } else {
      throw new Error(JSON.stringify(result.toString()));
    }
  } catch (e) {
    yield put(signInWithGoogleFailureAction(e.toString()));
  }
}
